/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { fetchVideo, fetchVideos } from './action';

export const videoSlice = createSlice({
  name: 'video',
  initialState: {
    videos: [],
    count: 0,
    video: null,
    isLoading: true,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchVideos.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchVideos.fulfilled, (state, action) => {
        state.videos = action.payload.data;
        state.count = action.payload.count;
        state.isLoading = false;
      })
      .addCase(fetchVideos.rejected, (state, action) => {
        state.error = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchVideo.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchVideo.fulfilled, (state, action) => {
        state.video = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchVideo.rejected, (state, action) => {
        state.error = action.payload;
        state.isLoading = false;
      });
  },
});

export default videoSlice.reducer;
